@if (viewMode === 'list') {
  <div class="master-container">
    <lib-dynamic-listing
      [module]="masterType"
      [columns]="columnConfigs"
      [data]="tableData"
      [actions]="actionConfigs"
      [isLoading]="isLoading"
      [pageIndex]="pageIndex"
      [rowsPerPage]="rowsPerPage"
      [totalCount]="totalCount"
      [totalPages]="totalPages"
      [showIncludeInactiveCheckbox]="true"
      [includeInactive]="showInactives"
      (actionClicked)="onActionClicked($event)"
      (pageChanged)="onPageChanged($event)"
      (includeInactiveChanged)="showInactives = $event; onShowInactivesChange()">
    </lib-dynamic-listing>
  </div>
} @else {
  <div class="master-form-container">
    <div class="form-content">
      <app-dynamic-form
        [isLoading]="isLoading"
        [data]="formFields"
        [formGroup]="formGroup"
        (fieldChanged)="onFormFieldChanged($event)">
      </app-dynamic-form>

      <div class="form-actions">
        <button type="button" pButton label="Save" (click)="onFormSubmit()" [disabled]="isLoading"></button>
        <button type="button" pButton label="Cancel" severity="secondary" (click)="onCancel()"></button>
      </div>
    </div>
  </div>
}
